<form #optionForm="ngForm"  novalidate *ngIf="show">
    <div class=" " *ngFor="let field of optionFields;let i=index">
      <div class="form-group"
           [ngClass]="{
           'two-col': field.length % 2 === 0,
           'three-col': field.length % 3 === 0
          }">
        <div class="d-flex" *ngIf="canShowOption(field)">
          <label class="col-sm-3 ps-2 col-form-label no-padding-right left-pos">
           <span class="labelWithToolTip no-padding-y"
                 [ngClass]="[ (field[0].indentNumber> 0 && i >0) ? 'childindent' + field[0].indentNumber :'']"
                 [ngStyle]="{'text-indent.px': (i >0 ?field[0].indentNumber * 15:'') }">

          {{((field[0].option.type===getOption().OPTION_TYPE_FABRIC)?'doctrine.fabric.fabric':field[0].option.name)|translate}}{{!field[0].option.status || field[0].option.deleted ? ' (' + ('global.inactive'| translate) + ')' : ''}}
             <span *ngIf="field[0].option.required">*</span>
<!--             {{optionForm.valid}}-->
               </span>
            <!--tooltip-item-->
            <span class="tooltip-item" *ngIf="field[0].option.systemDescription && i==0">
            <span class="tooltipBox">
              <i class="fa fa-info-circle fa-2x " aria-hidden="true" style="display: block"></i>
            </span>
            <span class="desc-place">
              <ng-container>
                <div>
                  {{field[0].option.description}}
                </div>
              </ng-container>
            </span>
          </span>
          </label>
          <div class="col-sm-9" [ngClass]="[field.length==1?'':'p-0']">

  <div [ngClass]="[field.length==1?'':'d-flex']" >
    <div *ngFor="let optionLocal of field;let j=index" [ngClass]="{'col-sm-6':  field.length % 2 === 0 || field.length % 5 === 0,
                                                  'col-sm-4':field.length % 3 === 0}">
      <ng-select #selectInput
        [name]="'optionItem'+j+i+orderItemIndex"
        [attr.data-testid]="optionLocal.option?.id ? 'option-select-' + optionLocal.option.id : null"
        #optionItemm="ngModel"
        [ngClass]="{'border':optionLocal.option.required}"
        [(ngModel)]="optionLocal['optionSelected']"
        [required]="optionLocal.option.required || optionLocal.AsFabricCollection || optionLocal.AsFabric || optionLocal.AsFabricColor"
        (change)="onChangeChildOptions(optionLocal['optionSelected'],i,j,optionLocal, orderItemIndex,field);"
        bindValue="id"
        bindLabel="name"
        [items]="optionLocal.children"
        (open)="getPreparedChildItems(optionLocal, optionLocal.children, optionLocal['optionSelected'])"
        placeholder="{{(optionLocal.AsFabricCollection || optionLocal.AsFabric || optionLocal.AsFabricColor ? ( 'global.selectbox_placeholder'|translate) : (optionLocal.option.required ? 'global.selectbox_placeholder' : 'global.standard')) | translate}}"
        [clearable]="isCarpetRoleOption(optionLocal)"
        [autofocus]="[checkIfAutoFocused(i, optionFields), selectInput]">
      </ng-select>
      <div class="messages text-danger"
           *ngIf="optionItemm.invalid && parentFormChecked && optionItemm.errors?.required">
        {{'errors.required'|translate}}
      </div>
    </div>
  </div>




          </div>


        </div>
      </div>
    </div>
    <ng-container *ngIf="localOptions.length>0 ">
    </ng-container>
  </form>


<!--<div class="form-group"-->
<!--[ngClass]="{'two-col': productItem.orderItemProductFabricCollection.fabricCollection && !productItem.orderItemProductFabricCollection.fabric, 'three-col':productItem.orderItemProductFabricCollection.fabricCollection && productItem.orderItemProductFabricCollection.fabric}">-->
<!--<div class="container">-->
<!--<div class="row">-->
<!--<label class="col-form-label col-sm-5 no-padding">Fabric<span>*</span></label>-->
<!--<div class="col-sm-7 no-padding ">-->
<!--<div-->
<!--[ngClass]="{'row': productItem.orderItemProductFabricCollection.fabricCollection}">-->
<!--<div [ngClass]="{'col-sm-6': productItem.orderItemProductFabricCollection.fabricCollection && !productItem.orderItemProductFabricCollection.fabric,-->
<!--'col-sm-4':productItem.orderItemProductFabricCollection.fabricCollection && productItem.orderItemProductFabricCollection.fabric}">-->
<!--<ng-select-->
<!--[name]="'fabricCollection'+productItem.random"-->
<!--#fabricCollection="ngModel"-->
<!--[(ngModel)]="productItem.orderItemProductFabricCollection.fabricCollection"-->
<!--(change)="getFabric(i,j,productItem.orderItemProductFabricCollection.fabricCollection)"-->
<!--bindValue="id"-->
<!--bindLabel="name"-->
<!--(search)="filterFabricCollection(i,j, $event)"-->
<!--[items]="productItem.orderItemProductFabricCollection.fabricsCollections"-->
<!--required>-->
<!--</ng-select>-->
<!--</div>-->
<!--<div [ngClass]="{'col-sm-6': productItem.orderItemProductFabricCollection.fabricCollection && !productItem.orderItemProductFabricCollection.fabric ,-->
<!--'col-sm-4':productItem.orderItemProductFabricCollection.fabricCollection && productItem.orderItemProductFabricCollection.fabric}"-->
<!--*ngIf="productItem.orderItemProductFabricCollection.fabricCollection">-->
<!--<ng-select-->
<!--[name]="'fabric'+productItem.random"-->
<!--#fabricCollection="ngModel"-->
<!--[(ngModel)]="productItem.orderItemProductFabricCollection.fabric"-->
<!--(change)="getFabricColor(i,j,productItem.orderItemProductFabricCollection.fabric)"-->
<!--bindValue="id"-->
<!--bindLabel="name"-->
<!--(search)="filterFabric(i,j, $event)"-->
<!--[items]="productItem.orderItemProductFabricCollection.fabrics"-->
<!--required>-->
<!--</ng-select>-->
<!--</div>-->

<!--<div-->
<!--[ngClass]="{'col-sm-4':productItem.orderItemProductFabricCollection.fabricCollection && productItem.orderItemProductFabricCollection.fabric}"-->
<!--*ngIf="productItem.orderItemProductFabricCollection.fabricCollection && productItem.orderItemProductFabricCollection.fabric">-->


<!--<ng-select-->
<!--[name]="'fabricColor'+productItem.random"-->
<!--#fabricCollection="ngModel"-->
<!--[(ngModel)]="productItem.orderItemProductFabricCollection.fabricColor"-->
<!--bindValue="id"-->
<!--bindLabel="name"-->
<!--(change)="changeFabricColor(i,j,productItem.orderItemProductFabricCollection.fabricColor)"-->
<!--(search)="filterFabricColor(i,j, $event)"-->
<!--[items]="productItem.orderItemProductFabricCollection.fabricColors"-->
<!--required>-->
<!--</ng-select>-->


<!--</div>-->

<!--</div>-->

<!--</div>-->
<!--</div>-->
<!--</div>-->
<!--</div>-->
